/* template */
<template minapp="mpx" xlang="wxml"><div class="es-radio-group" :class='[$attrs["custom-class"],(classnames)]'><slot/></div></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m10772dd7"}'>
  @import '../common/style/bem'

  +b('radio-group')
    display flex
    flex-wrap wrap
    +m('column')
      flex-direction column
    +m('row')
      flex-direction row
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m10772dd7"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex10772dd7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex10772dd7%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m10772dd7"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index10772dd7/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
